module.exports = __webpack_public_path__ + "media/1D_RockCharacterization.4c5ebd22.mp4";